import axios from 'axios'

export default {
    async bookDemo(data) {
        try{           
            const response = await axios.post(`Registration/book-demo`, data)              
            return response
        }catch (error){
            console.log('bookDemo api error')
            throw error
        }
    },
}